import React from "react";
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import {faEye} from '@fortawesome/free-solid-svg-icons';
import {Button, Card, Col, Row, Table} from '@themesberg/react-bootstrap';
import BasePage from "./../base/BasePage";
import label from "enqc-utilities/src/label/Label"
import PaginationTable from "../../components/PaginationTable";
import {getUser} from "../../utils/StorageUtil";
import {Link} from "react-router-dom";
import {Routes} from "../../routes";
import Endpoint from "enqc-utilities/src/api/Endpoint";
import queryString from 'query-string';
import {currencyFormat, navigate, parseDate} from "enqc-utilities/src/utils/Utilities";
import {DD_MMMM_YYYY_HH_MM_SS} from "../../utils/Global";
import OrderDetailPage from "./OrderDetailPage";
import SearchInput from "../../components/input/SearchInput";
import TableSortOption from "../../components/input/TableSortOption";
import SortOption from "enqc-utilities/src/model/SortOption";

class ProductOrderPage extends BasePage {
  constructor(props) {
    super(props);
    this.state = {
      inputSearch: queryString.parse(this.props.query).search ? queryString.parse(this.props.query).search : "",
      user : getUser(),
      page: queryString.parse(props.query).page ? queryString.parse(props.query).page : 1,
      productOrders:[],
      totalPage: 0,
      totalElement: 0,
      pageElement: 0,
      sortOption:{}
    }
  }

  componentDidMount() {
    super.componentDidMount();
    if(this.props?.navBar?.current){
      this.props.navBar.current.updateNavBarItems([ProductOrderPage.PAGE_CONF])
    }
    this.closePreLoader()
    this.fetchProductOrders()
  }

  componentWillReceiveProps(props, nextContext) {
    if (props != this.props) {
      let page = queryString.parse(props.query).page ? queryString.parse(props.query).page : 1
      let key = queryString.parse(props.query).tab ? queryString.parse(props.query).tab : label.All
      let inputSearch = queryString.parse(props.query).search ? queryString.parse(props.query).search : ""
      this.setState({
        page: page,
        key: key,
        inputSearch: inputSearch
      }, () => {
        this.fetchProductOrders()
      })
    }
  }


  fetchProductOrders = () => {
    let {user,productOrders, search, sortOption} = this.state
    this.get(Endpoint.API.PRODUCT_ORDERS, {
      params :{
        userId : user.id,
        ascending: sortOption.ascending,
        sortir: sortOption.sortir,
        search: search,
        page: this.state.page - 1,
      }
    }, null, response=>{
      if(response.code===200){
        let productOrders = response.data
        let totalPage = response.totalPage
        let totalElement = response.totalElement
        let pageElement = response.pageElement
        this.setState({productOrders:productOrders,totalPage, totalElement, pageElement})
      }else{
        this.props.history.goBack();
      }
    }, false, true)
  }



  render() {
    let {user, productOrders, page, pageElement, totalPage, totalElement, sortOption} = this.state
    return (
        <>
          <h4>{label.HistoryOfYourProductOrder}</h4>
          <div className="table-settings mb-4">
            <Row className="align-items-center">
              <Col xs={4} md={6} lg={9} xl={8} className="ps-md-0 text-right">
                <TableSortOption
                    sortOptions={
                      [
                        SortOption.init(label.Oldest,"ja.created",true),
                        SortOption.init(label.Latest,"ja.created",false),
                        SortOption.init(label.TheMost,"ja.itemCount",false),
                        SortOption.init(label.Smallest,"ja.itemCount",true),
                      ]
                    }
                    sortOption={sortOption}
                    placeholder={label.SortBy}
                    onSelect={(sortOption) => {
                      this.setState({sortOption},() => {
                        this.fetchProductOrders()
                      })
                    }}
                    onReset={() => {
                      this.setState({sortOption:{}},() => {
                        this.fetchProductOrders()
                      })
                    }}/>
              </Col>
              <Col xs={8} md={6} lg={3} xl={4}>
                <SearchInput onEnter={(search) => {
                  this.setState({search}, () => {
                    this.fetchProductOrders()
                  })
                }} onEmpty={() => {
                  this.setState({search:""},() => {
                    this.fetchProductOrders()
                  })
                }}/>
              </Col>
            </Row>
          </div>
          <Card border="light" className="table-wrapper table-responsive shadow-sm">
            <Card.Body className="pt-0">
              <Table hover className="table-sm user-table align-items-center">
                <thead>
                <tr>
                  <th className="border-bottom">#</th>
                  <th className="border-bottom">{label.Reference}</th>
                  <th className="border-bottom">{label.ProductOrderItem}</th>
                  <th className="border-bottom">{label.Created}</th>
                  <th className="border-bottom">Total</th>
                  <th className="border-bottom">Status</th>
                  <th className="border-bottom">Action</th>
                </tr>
                </thead>
                <tbody>
                {productOrders.map((productOrder, index) => (
                    <tr>
                      <td>
                        <Card.Link as={Link} to={Routes.Invoice.path} className="fw-normal">
                          {((page - 1) * pageElement) + (++index)}
                        </Card.Link>
                      </td>
                      <td><span className="fw-normal">{productOrder.reference}</span>
                      </td>
                      <td><span className="fw-normal">{productOrder.itemCount}</span>
                      </td>
                      <td><span className="fw-normal">{parseDate(productOrder.created, DD_MMMM_YYYY_HH_MM_SS)}</span>
                      </td>
                      <td><span className="fw-normal">{currencyFormat(productOrder.totalProductOrderAmount, 'Rp')}</span>
                      </td>
                      <td><span className={`fw-normal`} style={{color:productOrder.productOrderStatus.color}}>{productOrder.productOrderStatus.label}</span>
                      </td>
                      <td>
                        <Button
                            size="sm"
                            className="rounded-circle text-center"
                            onClick={(e) => {
                              e.preventDefault()
                              navigate(this.props, OrderDetailPage.ENDPOINT+"/"+productOrder.reference)
                            }}
                            type={Link}>
                          <FontAwesomeIcon icon={faEye}/>
                        </Button>
                      </td>
                    </tr>
                ))}
                </tbody>
              </Table>
            </Card.Body>
            <PaginationTable
                onSelect={() => {

                }}
                currentPage={page}
                pageCount={totalPage}
                totalElement={totalElement}/>
          </Card>
          {/*<TransactionsTable/>*/}
        </>
    );
  }
}
//export default Object.assign(ProductOrderPage, {ENDPOINT : "/productOrders"})
const ENDPOINT = "/productOrders"
const TITLE = label.ProductOrder
const PAGE = {ENDPOINT: ENDPOINT, PAGE_CONF: {ENDPOINT, TITLE}}
export default Object.assign(ProductOrderPage, PAGE)

